import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BloodGlucoseLogPage = lazy(() => import("./BloodGlucoseLogPage"));

const BloodGlucoseLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BloodGlucoseLogPage />
    </Suspense>
  );
};

export default BloodGlucoseLogPageLazy;
